// Sentry MUST be imported FIRST for auto-instrumentation
import './lib/sentry';

import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { ReactFlowProvider } from '@xyflow/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './index.css';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Global fetch patch: rewrite /api calls to absolute VITE_API_URL in ACA
const API_BASE = (import.meta as any).env?.VITE_API_URL?.trim?.();
if (typeof API_BASE === 'string' && API_BASE && !API_BASE.startsWith('/')) {
  const origFetch = window.fetch.bind(window);
  window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
    const url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : String(input as any);
    if (url.startsWith('/api/')) {
      const base = API_BASE.replace(/\/$/, '');
      const rest = url.replace(/^\/api\/v1/, '');
      const absolute = base + rest;
      return origFetch(absolute, init);
    }
    return origFetch(input as any, init);
  };
}

// NOTE: StrictMode temporarily disabled to fix request abort issues during testing
// In development, StrictMode double-mounts components which causes API requests to be aborted
// TODO: Re-enable after implementing proper AbortController cleanup in useEffect hooks
ReactDOM.createRoot(document.getElementById('root')!).render(
  // <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ReactFlowProvider>
        <App />
      </ReactFlowProvider>
    </QueryClientProvider>
  // </StrictMode>
);
